var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWiki = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.885,
    height: 14.764,
    viewBox: "0 0 22.885 14.764",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#96b4b6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.879,17.414,18.308,17.4c0,.166,0,.365,0,.5A1.877,1.877,0,0,1,20,18.906L15.619,29.011c-.214-.5-2.251-5.025-2.483-5.606l2.117-4.392a2.676,2.676,0,0,1,2.081-1.13l0-.459-4.4,0c-.011.116,0,.361-.016.483,1.241.034,1.684.311,1.387,1.052-.491,1.115-1.519,3.227-1.721,3.612-.629-1.315-1.029-2.327-1.714-3.749-.3-.659.357-.915,1.047-.935V17.42L6.825,17.4c0,.217,0,.339,0,.5.71.011,1.631.087,2,.7.487.948,2.111,4.713,2.6,5.722-.627,1.2-2.149,4.047-2.694,5.115-.781-1.734-3.672-8.563-4.489-10.326-.3-.751.871-1.185,1.551-1.217l0-.5H0c0,.151.006.4.007.51.939-.009,2.313,1.534,2.7,2.493C4.4,24.326,6.147,28.226,7.829,32.153a5.058,5.058,0,0,0,.532,0c1.1-2.253,2.387-4.621,3.549-6.9l2.931,6.9s.486,0,.489,0c1.858-4.247,4.643-10.764,5.554-12.821a2.109,2.109,0,0,1,1.994-1.446l.007-.457Z",
    transform: "translate(0 -17.398)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWiki, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wiki.3454ac7e.svg";
export { ForwardRef as ReactComponent };